import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmCalibreForm from '../../../components/forms/FirearmCalibreForm';
import { useCreateFirearmCalibre } from '../../../hooks/useFirearmCalibreApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmCalibreDTO } from '../../../services/apiClient';

const FirearmCalibreCreate: React.FC = () => {
  const createFirearmCalibre = useCreateFirearmCalibre();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Calibres', href: '/admin/firearmcalibres' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmCalibreDTO) => {
    try {
      await createFirearmCalibre.mutateAsync(data);
      navigate('/admin/firearmcalibres');
    } catch (error) {
      console.error('Error creating FirearmCalibre:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmcalibres"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmCalibre.Edit'
    >
        <FirearmCalibreForm
          initialValues={{} as FirearmCalibreDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmcalibres')}
        />
    </AdminLayout>
  );
};

export default FirearmCalibreCreate;